<bim-header></bim-header>

<div class="container-fluid">
    <div class="main-container">
        <router-outlet></router-outlet>
        <router-outlet name="popup"></router-outlet>
        <ng-container *ngIf="showGlobalSpinner$ | async as globalSpinner">
            <div class="global-loading-container" [hidden]="!globalSpinner">
                <div class="global-loading-spinner d-flex justify-content-center">
                    <app-spinner></app-spinner>
                </div>
                <p *ngIf="globalSpinner && globalSpinner != ''" class="global-loading-text">{{globalSpinner}}
                    <app-spinner class="ellipsis-spinner" [style]="'ellipsis'"></app-spinner>
                </p>
            </div>
        </ng-container>
    </div>
</div>

<bim-footer></bim-footer>
